import React, { useState, useMemo, useEffect } from 'react';
import './AssetSelector.css'; // Mantenha seu CSS
import { IAtivosModel } from './types'; // Mantenha sua importação de tipos

// As props devem ser para Ativos
interface AssetSelectorProps {
    assets: IAtivosModel[];
    onSelectionChange: (selectedAssets: IAtivosModel[]) => void;
    httpClient: any;
}

// O componente de exibição do ícone
const IconDisplay: React.FC<{ icon: IAtivosModel['associatedIcon'] }> = ({ icon }) => {
    // A lógica de renderização é a mesma, apenas garantindo que está aqui.
    if (!icon || !icon.Value) {
        return <div className="asset-icon-placeholder" />; // Espaço reservado para alinhar a lista
    }

    // Renderiza SVG se existir
    if (icon.Value.SVG && icon.Value.SVG.trim() !== '') {
        return (
            <div
                className="asset-icon"
                style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                dangerouslySetInnerHTML={{ __html: icon.Value.SVG }}
            />
        );
    }

    // Renderiza a CLASSE se existir (usando Material Icons)
    if (icon.Value.Class && icon.Value.Class.trim() !== '') {
        return (
            <div className="asset-icon" style={{ width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <span className="material-icons-outlined" style={{ fontSize: '20px' }}>
                    {icon.Value.Class}
                </span>
            </div>
        );
    }

    return <div className="asset-icon-placeholder" />; // Espaço reservado se Value estiver vazio
};


export const AssetSelector: React.FC<AssetSelectorProps> = ({ assets, onSelectionChange, httpClient }) => {
    const [filterText, setFilterText] = useState('');
    const [selectedIds, setSelectedIds] = useState<number[]>([]);

    const filteredAssets = useMemo(() => {
        if (!filterText) return assets;
        return assets.filter(asset =>
            `${asset.Ativo} ${asset.Descricao || ''}`.toLowerCase().includes(filterText.toLowerCase())
        );
    }, [filterText, assets]);

    const handleToggleSelection = (assetId: number) => {
        const newSelectedIds = selectedIds.includes(assetId)
            ? selectedIds.filter(id => id !== assetId)
            : [...selectedIds, assetId];
        setSelectedIds(newSelectedIds);
    };

    useEffect(() => {
        const selectedModels = assets.filter(asset => selectedIds.includes(asset.IdAtivo));
        onSelectionChange(selectedModels);
    }, [selectedIds, assets, onSelectionChange]);


    return (
        <div className="asset-selector-container">
            <label htmlFor="filter">Buscar Ativo:</label>
            <input
                type="text"
                id="filter"
                placeholder="Filtrar por nome ou descrição..."
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
            />

            <label>Selecionar Ativos:</label>
            <ul className="asset-list">
                {filteredAssets.map(asset => (
                    <li
                        key={asset.IdAtivo}
                        className={`asset-list-item ${selectedIds.includes(asset.IdAtivo) ? 'selected' : ''}`}
                        onClick={() => handleToggleSelection(asset.IdAtivo)}
                    >
                        <div className="asset-info">
                            <input
                                type="checkbox"
                                checked={selectedIds.includes(asset.IdAtivo)}
                                readOnly
                            />
                            <span className="asset-text">{asset.Ativo} - {asset.Descricao}</span>
                        </div>
                        {/* A chamada ao IconDisplay que renderiza o ícone */}
                        <IconDisplay icon={asset.associatedIcon} />
                    </li>
                ))}
            </ul>
        </div>
    );
};